import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { Menu } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="w-full px-4 lg:px-6 h-20 flex items-center border-b border-gray-200 dark:border-stone-800 bg-white dark:bg-[#121212] sticky top-0 z-50">
        <div className="w-full flex items-center justify-between">
          <div className="shrink-0">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/wealthscale_light.svg" alt="WealthScale Logo" className="h-8 w-auto block dark:hidden" />
              <img src="/wealthscale_dark.svg" alt="WealthScale Logo" className="h-8 w-auto hidden dark:block" />
              <span className="font-serif text-base font-semibold text-foreground sm:text-lg">
                WealthScale
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3 lg:gap-4">
            <ThemeToggle />
            <Link className="text-sm" to="/login">
              Login
            </Link>

            <Button asChild>
              <Link to="/register">Sign up</Link>
            </Button>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <ThemeToggle />
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <Menu className="h-6 w-6" />
            </Button>
          </div>
        </div>
      </header>

      {mobileMenuOpen && (
        <MobileMenu onClose={() => setMobileMenuOpen(false)} />
      )}
    </>
  );
}

function MobileMenu({ onClose }: { onClose: () => void }) {
  return (
    <div className="md:hidden fixed inset-0 z-40 bg-white dark:bg-[#121212] pt-20">
      <nav className="flex flex-col p-4">
        <Button variant="outline" className="w-full" asChild>
          <Link to="/login" onClick={onClose}>
            Login
          </Link>
        </Button>
        <Button className="w-full mt-3" asChild>
          <Link to="/register" onClick={onClose}>
            Sign up
          </Link>
        </Button>
      </nav>
    </div>
  );
}
